module.exports = __webpack_public_path__ + "static/media/planning-name.946a84b5.svg";